<template>
	<div>
    <section v-if="showError" class="hero is-danger">
      <div class="hero-body">
        <p class="title">
          U heeft geen toegang tot deze pagina!
        </p>
        <p class="subtitle">
          ID van website niet goed! ({{id}})<br /><br />
          <i class="fas fa-exclamation-triangle"></i> Contacteer <i>jelle@weerstandnatuursteen.nl</i> 
        </p>
      </div>
    </section>

    <div v-else>
      <Formulier></Formulier>
    </div>
    
	</div>
</template>

<script>
import SideView from './SideView.vue'
import Formulier from './Formulier.vue'

export default {
  name: 'Home',
  data () {
    return {
      showError: false,
      id: this.config.id,
    }
  },

  methods: {
    
  },

  mounted() {
    this.axios.get("https://backend.weerstandgrafmonumenten.nl/api/contacts/get/" + this.config.id).then(response => {
        if (response.data.length == 0) {
          this.showError = true
        }
    })
  },

  components: {
    SideView, Formulier
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Home.vue